import { render } from "./SearchPage.vue?vue&type=template&id=7dc73094"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__